import {
  applyMiddleware,
  combineReducers,
  createStore
} from 'redux'
import { Store } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import reduxThunk from 'redux-thunk'
import { ui } from './reducers/ui'
import { createConsentBannerSideEffect } from './sideEffects/consentBanner'
import { InitialState, IState } from './state'

export const createClientStore = (): Store<IState> => {
  const reducer = combineReducers<IState>({
    ui,
  })

  return createStore(
    reducer,
    InitialState.app(),
    composeWithDevTools(
      applyMiddleware(
        reduxThunk,
        createConsentBannerSideEffect(),
      )
    )
  )
}
